import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9a18dd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-desktop" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Basic information", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Be descriptive and name your event.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Date and time", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Set when your event starts and ends.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Scanning options", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Choose an option that fit your event", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Team Management", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Define who can manage your event.", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Setup", -1))
const _hoisted_15 = {
  class: "flex-desktop",
  style: {"margin-top":"30px"}
}
const _hoisted_16 = { class: "horizontal-tabs" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Basic informations", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Date and time", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Scanning options", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Team management", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  class: "full-width",
  style: {"margin-right":"30px"}
}

import { IonLabel, IonPage, IonItem, IonContent, IonIcon } from "@ionic/vue";
import {
  createOutline,
  personCircleOutline,
  calendarOutline,
  qrCodeOutline,
} from "ionicons/icons";

import { useContextStore } from "@/stores/context";
import EventSidebar from "@/views/_partials/EventSidebar.vue";
import SettingDetails from "@/views/Event/pages/Settings/Details.vue";
import SettingDate from "@/views/Event/pages/Settings/Date.vue";
import SettingScan from "@/views/Event/pages/Settings/Scan.vue";
import ManageTeam from "./ManageTeam.vue";
import { useAppStore } from "@/stores/app";
import { useWindowWidth } from "@/composition/window";
import { computed, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const appStore = useAppStore();

const settingsMenu = ref("");

onMounted(() => {
  if (!isMobile.value) {
    settingsMenu.value = "basic";
  }
});

const setMenu = (menu: string) => {
  settingsMenu.value = menu;
};

const dark_mode = computed(() => appStore.settings.theme === "dark");


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(EventSidebar, {
                  key: 0,
                  event: _unref(contextStore).event
                }, null, 8, ["event"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(dark_mode.value ? 'full-width' : 'colored-bg full-width')
            }, [
              (_unref(isMobile) && !settingsMenu.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                    _createVNode(_unref(IonItem), {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (setMenu('basic')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonIcon), {
                          class: "mngr_icon",
                          icon: _unref(createOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (setMenu('date-time')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonIcon), {
                          class: "mngr_icon",
                          icon: _unref(calendarOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (setMenu('scan')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonIcon), {
                          class: "mngr_icon",
                          icon: _unref(qrCodeOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (setMenu('team')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _hoisted_10
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonIcon), {
                          class: "mngr_icon",
                          icon: _unref(personCircleOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]))
                : (_unref(isMobile) && settingsMenu.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                      (settingsMenu.value === 'basic')
                        ? (_openBlock(), _createBlock(SettingDetails, {
                            key: 0,
                            onCancel: _cache[4] || (_cache[4] = ($event: any) => (setMenu('')))
                          }))
                        : _createCommentVNode("", true),
                      (settingsMenu.value === 'date-time')
                        ? (_openBlock(), _createBlock(SettingDate, {
                            key: 1,
                            onCancel: _cache[5] || (_cache[5] = ($event: any) => (setMenu('')))
                          }))
                        : _createCommentVNode("", true),
                      (settingsMenu.value === 'scan')
                        ? (_openBlock(), _createBlock(SettingScan, {
                            key: 2,
                            onCancel: _cache[6] || (_cache[6] = ($event: any) => (setMenu('')))
                          }))
                        : _createCommentVNode("", true),
                      (settingsMenu.value === 'team')
                        ? (_openBlock(), _createBlock(ManageTeam, {
                            key: 3,
                            onCancel: _cache[7] || (_cache[7] = ($event: any) => (setMenu('')))
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["horizontal-tab", { active: settingsMenu.value === 'basic' }]),
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (setMenu('basic')))
                            }, _hoisted_18, 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["horizontal-tab", { active: settingsMenu.value === 'date-time' }]),
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (setMenu('date-time')))
                            }, _hoisted_20, 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["horizontal-tab", { active: settingsMenu.value === 'scan' }]),
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (setMenu('scan')))
                            }, _hoisted_22, 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["horizontal-tab", { active: settingsMenu.value === 'team' }]),
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (setMenu('team')))
                            }, _hoisted_24, 2)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            (settingsMenu.value === 'basic')
                              ? (_openBlock(), _createBlock(SettingDetails, { key: 0 }))
                              : _createCommentVNode("", true),
                            (settingsMenu.value === 'date-time')
                              ? (_openBlock(), _createBlock(SettingDate, { key: 1 }))
                              : _createCommentVNode("", true),
                            (settingsMenu.value === 'scan')
                              ? (_openBlock(), _createBlock(SettingScan, { key: 2 }))
                              : _createCommentVNode("", true),
                            (settingsMenu.value === 'team')
                              ? (_openBlock(), _createBlock(ManageTeam, { key: 3 }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})